import React from 'react';
import './BookingStepIntro.css';
import { BOOKING_STEPS, STEP_SUBTITLES, STEP_TITLES } from '../../constants/bookingSteps';

interface BookingStepIntroProps {
    step: number;
}

const MODALITY_HINT =
    'Podrás añadir o modificar servicios más adelante durante la reserva.';

const EXTRAS_HINT =
    'Puedes añadir tantos extras como quieras.';

const BookingStepIntro: React.FC<BookingStepIntroProps> = ({ step }) => {
    const title = STEP_TITLES[step];
    const subtitle = STEP_SUBTITLES[step];
    const bannerHint =
        step === BOOKING_STEPS.MODALITY
            ? MODALITY_HINT
            : step === BOOKING_STEPS.EXTRAS
                ? EXTRAS_HINT
                : null;

    return (
        <div className="booking-step-intro">
            <h2 className="booking-step-intro-title">{title}</h2>
            {subtitle && <p className="booking-step-intro-subtitle">{subtitle}</p>}
            {bannerHint && (
                <div className="booking-step-intro-banner" role="note">
                    <span className="booking-step-intro-banner-icon" aria-hidden="true">
                        i
                    </span>
                    <p>{bannerHint}</p>
                </div>
            )}
        </div>
    );
};

export default BookingStepIntro;
